<template>
  <AthleteField :label="label">
    <p
      class="m-0 mb-1 font-medium text-gray-900"
      v-html="value"
      :class="{'ds-text-base': !primary, 'ds-text-xl lg:ds-text-2xl': primary}"
    ></p>
  </AthleteField>
</template>

<script>
import AthleteField from "./AthleteField";
export default {
  components: {
    AthleteField
  },
  props: {
    label: { required: true },
    value: { required: true },
    primary: { required: false, default: false, type: Boolean }
  }
};
</script>

<style scoped>
</style>
